import { EntityType } from '../../../../../generated/data-contracts';

// Función para obtener el nombre de la entidad
export const getEntityName = (permission: any) => {
  if (!permission.entity) return `ID: ${permission.entityId}`;

  switch (permission.entityType) {
    case EntityType.CLIENT:
      return (
        permission.entity.clientName || `Cliente ID: ${permission.entityId}`
      );
    case EntityType.PLANT:
      return permission.entity.plantName || `Planta ID: ${permission.entityId}`;
    case EntityType.DASHBOARDGROUP:
      return permission.entity.groupName || `Grupo ID: ${permission.entityId}`;
    case EntityType.DASHBOARD:
      return (
        permission.entity.dashboardName ||
        `Dashboard ID: ${permission.entityId}`
      );
    case EntityType.ALERT:
      return permission.entity.name || `Alerta ID: ${permission.entityId}`;
    case EntityType.DIAGRAM:
      return permission.entity.name || `Diagrama ID: ${permission.entityId}`;
    default:
      return `ID: ${permission.entityId}`;
  }
};

// Función para obtener información adicional de la entidad
export const getEntitySecondaryInfo = (permission: any) => {
  if (!permission.entity) return '';

  switch (permission.entityType) {
    case EntityType.CLIENT:
      return permission.entity.clientEmail || '';
    case EntityType.PLANT:
      return permission.entity.clientEmail || '';
    case EntityType.DASHBOARDGROUP:
      return permission.entity.plantId
        ? `Planta ID: ${permission.entity.plantId}`
        : '';
    case EntityType.DASHBOARD:
      return permission.entity.dashboardGroupId
        ? `Grupo ID: ${permission.entity.dashboardGroupId}`
        : '';
    default:
      return '';
  }
};

// Función para obtener el nivel jerárquico requerido
export const getHierarchicalLevels = (
  entityType: EntityType
): ('plant' | 'zone' | 'table')[] => {
  switch (entityType) {
    case EntityType.DASHBOARDGROUP:
    case EntityType.DIAGRAM:
      return ['plant'];
    case EntityType.DASHBOARD:
      return ['plant'];
    case EntityType.ALERT:
      return ['plant', 'zone'];
    default:
      return [];
  }
};
